import { render, staticRenderFns } from "./GenericApp.vue?vue&type=template&id=0bddffdf&scoped=true"
import script from "./GenericApp.vue?vue&type=script&lang=js"
export * from "./GenericApp.vue?vue&type=script&lang=js"
import style0 from "./GenericApp.vue?vue&type=style&index=0&id=0bddffdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bddffdf",
  null
  
)

export default component.exports